import React, { useState } from 'react';
import { Card, Descriptions, Button } from 'antd';
import { useSelector } from 'react-redux';
import ShowUser from '../Users/ShowUser'; // Adjust the import path as necessary

const EventDetails = ({ match }) => {
  const { _id } = match.params;
  const EVENT = useSelector(state => 
    state.events?.data.find(el => String(el._id) === String(_id)) || {}
  );

  const [showUserVisible, setShowUserVisible] = useState(false);

  const handleShowUser = () => {
    setShowUserVisible(true);
  };

  const handleHideUser = () => {
    setShowUserVisible(false);
  };

  return (
    <Card
      style={{
        borderColor: 'rgba(0, 0, 255, .2)',
        marginBottom: 15,
        minWidth: 300,
        borderRadius: '5px',
      }}
      title={`Event: ${EVENT?.eventname}`}
    >
      <Descriptions bordered column={2}>
        <Descriptions.Item label="Name">{EVENT?.eventname}</Descriptions.Item>
        <Descriptions.Item label="Activity">{EVENT?.activity}</Descriptions.Item>
        <Descriptions.Item label="Company Name">{EVENT?.company?.name}</Descriptions.Item>
        <Descriptions.Item label="Company Address">{EVENT?.company?.address}</Descriptions.Item>
        <Descriptions.Item label="Company URL">{EVENT?.company?.url}</Descriptions.Item>
        <Descriptions.Item label="Company Description">{EVENT?.company?.description}</Descriptions.Item>
        <Descriptions.Item label="Country">{EVENT?.country?.name}</Descriptions.Item>
        <Descriptions.Item label="Location">{EVENT?.location}</Descriptions.Item>
        <Descriptions.Item label="Description">{EVENT?.description}</Descriptions.Item>
        <Descriptions.Item label="Email Template">{EVENT?.emailTemplate}</Descriptions.Item>
        <Descriptions.Item label="Participants">{EVENT?.participants}</Descriptions.Item>
        <Descriptions.Item label="Cost">{EVENT?.cost?.amount} {EVENT?.cost?.currency}</Descriptions.Item>
        <Descriptions.Item label="Status">{EVENT?.status}</Descriptions.Item>
        <Descriptions.Item label="Tags">{EVENT?.tags.join(', ')}</Descriptions.Item>
        <Descriptions.Item label="Organizer Email">
          {EVENT?.user?.email} 
      {/* ShowUser Component Drawer */}
      {EVENT?.user && (
        <ShowUser
          item={EVENT?.user}
          logo={false}
          visible={showUserVisible}
          onClose={handleHideUser}
        />
      )}
        </Descriptions.Item>
        <Descriptions.Item label="Organizer Phone">{EVENT?.user?.phone}</Descriptions.Item>
        <Descriptions.Item label="Organizer Address">{EVENT?.user?.address}</Descriptions.Item>
        <Descriptions.Item label="Start DateTime">{EVENT?.dateAndTime?.startDateTime}</Descriptions.Item>
        <Descriptions.Item label="End DateTime">{EVENT?.dateAndTime?.endDateTime}</Descriptions.Item>
        <Descriptions.Item label="Time Zone">{EVENT?.dateAndTime?.timeZone}</Descriptions.Item>
      </Descriptions>


    </Card>
  );
};

export default EventDetails;
